import React from "react";

export const RecommendationsCloseIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M12 24C9.62663 24 7.30655 23.2962 5.33316 21.9776C3.35977 20.6591 1.8217 18.7849 0.913451 16.5922C0.00519943 14.3995 -0.232441 11.9867 0.230582 9.65892C0.693605 7.33115 1.83649 5.19295 3.51472 3.51472C5.19295 1.83649 7.33115 0.693605 9.65892 0.230582C11.9867 -0.232441 14.3995 0.00519943 16.5922 0.913451C18.7849 1.8217 20.6591 3.35977 21.9776 5.33316C23.2962 7.30655 24 9.62663 24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24ZM12 21.6C13.8987 21.6 15.7548 21.037 17.3335 19.9821C18.9122 18.9273 20.1426 17.4279 20.8692 15.6738C21.5958 13.9196 21.786 11.9894 21.4155 10.1271C21.0451 8.26492 20.1308 6.55436 18.7882 5.21178C17.4456 3.8692 15.7351 2.95488 13.8729 2.58447C12.0107 2.21405 10.0804 2.40416 8.32624 3.13076C6.57207 3.85736 5.07276 5.08782 4.0179 6.66653C2.96304 8.24524 2.40001 10.1013 2.40001 12C2.40001 14.5461 3.41143 16.9879 5.21178 18.7882C7.01213 20.5886 9.45393 21.6 12 21.6ZM12 10.3L15.394 6.90601L17.094 8.60601L13.7 12L17.094 15.394L15.394 17.094L12 13.7L8.60601 17.094L6.90601 15.394L10.3 12L6.90901 8.60601L8.60901 6.90601L12 10.3Z"
      fill="#596970"
    />
  </svg>
);

export const RecommendationsPrevIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none" {...props}>
    <path
      d="M2.82832 6.99999L7.77832 2.04999L6.36432 0.635986L0.000320435 6.99999L6.36432 13.364L7.77832 11.95L2.82832 6.99999Z"
      fill="#242424"
    />
  </svg>
);

export const RecommendationsNextIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none" {...props}>
    <path
      d="M5.17168 6.99999L0.22168 2.04999L1.63568 0.635986L7.99968 6.99999L1.63568 13.364L0.22168 11.95L5.17168 6.99999Z"
      fill="#242424"
    />
  </svg>
);
